import { type RefObject, useEffect, useMemo, useState } from 'react';

type UseIsInViewportProps = {
	ref: RefObject<HTMLElement>;
	rootMargin?: string;
};

export const useInViewport = ({ ref, rootMargin = '0px 0px 200px 0px' }: UseIsInViewportProps) => {
	const [isInViewport, setIsInViewport] = useState(false);

	const observer = useMemo(
		() =>
			new IntersectionObserver(
				([entry]) => {
					setIsInViewport(entry.isIntersecting);
				},
				{
					rootMargin,
				},
			),
		[rootMargin],
	);

	useEffect(() => {
		if (ref.current) {
			observer.observe(ref.current);
			return () => observer.disconnect();
		}
	}, [observer, ref]);

	return {
		isInViewport,
	};
};
